import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import { PaginatedItems } from "../../components/pagination/Pagination";
import moment from "moment/moment";
import { int2ip } from "../../helpers/helpers";
import { logEventList } from "./logsTypeData";

const Logs = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeUser, setActiveUser] = useState(0);
    const [activeEvent, setActiveEvent] = useState(1);
    const [eventValue, setEventValue] = useState("");
    const [logableTypeValue, setLogableTypeValue] = useState("");

    const pagination = "&page=" + currentPage;
    const userIdParams = activeUser ? "&user_id=" + activeUser : "";
    const eventParams =
        eventValue.length > 0 && logableTypeValue.length > 0
            ? `&event=${eventValue}&logable_type=${logableTypeValue}`
            : "";

    const combinedParams = pagination + userIdParams + eventParams;

    const { data: logs } = useGetPageQuery("logs?per_page=20" + combinedParams);
    const { data: users } = useGetPageQuery("users?per_page=100");

    const activeEventHandler = (eventId, eventValue, typeVlalue) => {
        setActiveEvent(eventId);
        setEventValue(eventValue);
        setLogableTypeValue(typeVlalue);
    };

    return (
        <>
            {logs && users && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>Логи ({logs.total})</h1>
                        </div>

                        <div className="row">
                            <div className="col-12 col-sm-9 col-md-9">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th className="no-mobile">Менеджер</th>
                                            <th className="no-mobile">Подія</th>
                                            <th className="no-mobile">Інформація</th>
                                            <th className="no-mobile">Дата</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logs.data.map((log) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        {users?.data?.find((user) => user.id === log.user_id)?.name}
                                                        {/* <div>
                                                            <span className="badge bg-warning text-dark mx-1">
                                                                PC (Windows )
                                                            </span>
                                                            Chrome 75.0.3770.144
                                                        </div> */}
                                                        <div>
                                                            <span className="badge bg-secondary ">
                                                                IP: {int2ip(log.ip)}
                                                            </span>
                                                        </div>
                                                        <div className="on-mobile mt-2">
                                                            <table className="table table-bordered">
                                                                <tbody>
                                                                    {Object.keys(JSON.parse(log.changes)).map(
                                                                        (change) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{change}</td>
                                                                                    <td>
                                                                                        {
                                                                                            JSON.parse(log.changes)[
                                                                                                change
                                                                                            ]
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        }
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div class="note note-note on-mobile">
                                                            {logEventList.find(
                                                                (event) =>
                                                                    event.evenType === log.event &&
                                                                    event.logable_type === log.logable_type
                                                            ).title +
                                                                " " +
                                                                moment(log.created_at).format("DD.MM.YYYY HH:mm")}
                                                        </div>
                                                    </td>
                                                    <td className="no-mobile">
                                                        {
                                                            logEventList.find(
                                                                (event) =>
                                                                    event.evenType === log.event &&
                                                                    event.logable_type === log.logable_type
                                                            ).title
                                                        }
                                                    </td>
                                                    <td className="no-mobile">
                                                        <table className="table table-bordered">
                                                            <tbody>
                                                                {Object.keys(JSON.parse(log.changes)).map((change) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{change}</td>
                                                                            <td>{JSON.parse(log.changes)[change]}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td className="no-mobile">
                                                        {moment(log.created_at).format("DD.MM.YYYY HH:mm")}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                <nav>
                                    <PaginatedItems pageCount={logs.last_page} setCurrentPage={setCurrentPage} />
                                </nav>
                            </div>

                            <div className="col-12 col-sm-3 col-md-3">
                                {/* <div className="margin20">
                                    <Link to={"/logs_backup"} className="btn btn-success form-control">
                                        <i className="bi bi-database-fill"></i> Резервні копії
                                    </Link>
                                </div> */}

                                <div className="list-group margin20">
                                    <div
                                        onClick={() => setActiveUser(0)}
                                        className={
                                            activeUser === 0
                                                ? "list-group-item fake-a active"
                                                : "list-group-item fake-a"
                                        }
                                    >
                                        Всі менеджери
                                    </div>
                                    {users.data.map((user) => {
                                        return (
                                            <div
                                                key={user.id}
                                                className={
                                                    activeUser === user.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setActiveUser(user.id)}
                                            >
                                                {user.name}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="list-group margin20">
                                    {logEventList.map((event) => {
                                        return (
                                            <div
                                                onClick={() =>
                                                    activeEventHandler(event.id, event.evenType, event.logable_type)
                                                }
                                                className={
                                                    activeEvent === event.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                            >
                                                {event.title}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Logs;
